import styled from 'styled-components';
/**
 * Containere con i margini superiori e inferiori
 * come i FormItem per allineamento elementi
 */
export const InputMarginContainer = styled.div`
  position: relative;
  padding-top: 8px;
  padding-bottom: 24px;
`;
